import i18n from '@/i18n'

// Laravel's own message for every failed validation is English and says nothing; the field
// messages say what is wrong, so only this line is translated (AD-256).
const LARAVEL_INVALID = 'The given data was invalid.'

export function serverMessage(message) {
  return message === LARAVEL_INVALID ? i18n.t('editorV2.core.errors.invalidData') : message
}
